import React from 'react';
import Image from '@/components/Bicester/Image';
import { IconButton } from 'rsuite';

const Toolbar = ({ title, handleReset }: { title?: string; handleReset?: () => void }) => {
  return (
    <div className={`flex items-center h-[30px] ${title && 'mb-[36px]'}`}>
      {title && <div className="text-[20px] text-[#455255] mr-[30px]">{title}</div>}
      <div className="flex-auto flex items-center justify-between">
        {handleReset && (
          <IconButton className="flex items-center mr-[30px]" onClick={handleReset}>
            <Image src="/resources/images/reset.svg" />
            <div className="text-[12px] text-[#999999] ml-[5px]">重置</div>
          </IconButton>
        )}
      </div>
    </div>
  );
};

export default Toolbar;
